<template>
    <div class="modal fade text-xs-left" id="modalExecutor" tabindex="-1" v-if="$store.state.modalExecutor" >
        <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="card-header" style="border-radius: 0.27rem">
                <h4 class="card-title">{{ $t('tasks.titles.executor') }}</h4>
                <div class="heading-elements">
                    <button type="button" id="closeBtn" ref="closeModalExecut" class="btn btn-warning" data-dismiss="modal" @click="$store.state.modalExecutor = false">
                        <i class="icon-cross" style="color: white"></i>
                    </button>
                </div>
            </div>

            <div class="modal-body">
                

                <div class="form-group">
                    <fieldset class="form-group position-relative">
                        <input class="form-control border-primary" type="text" placeholder="" v-model="findbyaddr" >
                        <div class="form-control-position">
                            <i class="icon-search4 font-medium-4"></i>
                        </div>
                    </fieldset>

                    <!-- <div v-for="(eq,index) in listFiltered" :key="index" @click="clickEq(eq);" class="hand">
                        <a class="dropdown-item" :style="{fontFamily: fontFam}">
                            <i :class="[eq.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i> {{eq.name}}
                        </a>
                    </div> -->

                    <div class="list-group" style="max-height: 60vh; overflow-y: auto">
                        <a class="list-group-item hand" v-for="(eq,index) in listFiltered" :key="index" @click="clickEq(eq);">
                            <i :class="[eq.checked ? 'icon-checkbox-checked' : 'icon-checkbox-unchecked']"></i> {{eq.name}}
                        </a>
                    </div>



                </div>
                    
            </div>
            <div class="modal-footer">
                <div class="col-md-12" style="display: flex; align-content: center; justify-content: center;">
                    <button type="button" class="btn btn-success" @click="closeForm()">
                        <a style="color: white">
                            <i class="icon-check2"></i> {{ $t('tasks.buttons.choose') }}
                        </a>
                    </button>
                </div>
            
            </div>
        </div>
        </div>
    </div>
</template>

<script>

  export default {
    name: "modalExecutor",
    data(){
        return {
            result: null,
            findbyaddr: '',            
        }
    },
    components: { },
    props:{
        final_func: {type: Function, required: true},
        data: {type: Array, required: true, default: []},
    },
    methods:{

        clickEq(item){
            let index = null;
            item.checked = !item.checked;

            /*for (let i = 0; i < this.data.length; i++) {
                if(this.data[i].guidUser != item.guidUser){
                    this.data[i].checked = false;
                }
            }*/
        },
        closeForm(){
            let arr = [];
            for (let i = 0; i < this.data.length; i++) {
                if(this.data[i].checked){
                    arr.push(this.data[i].guidUser);
                }
            }

            if(arr.length > 0){
                this.final_func(arr);
                this.$refs.closeModalExecut.click();
            }
        }
    },
    computed: {
        //find by address
        listFiltered: function(){
            let find = this.findbyaddr.toLowerCase();

            this.pageNumber = 0;

            return this.data.filter(item => {
                if( (find == '') || ((item.name != null) && (item.name.toLowerCase().indexOf(find) > -1)) ){
                    return item;
                }
            })
        },
        //find by address
    },
    mounted(){
        
    },
    created(){
        $(document).on('click', '#modalExecutor', function (e) {
            e.preventDefault();
            var modalDialog = $(e.target).find('.modal-dialog');
            
            if(modalDialog != null){
                try{
                    var xOffset = modalDialog.offset().left;
                    var yOffset = modalDialog.offset().top;

                    if(e.pageX <= xOffset + modalDialog.width()
                            && e.pageX>= xOffset 
                            && e.pageY <= yOffset + modalDialog.height()
                            && e.pageY>= yOffset){} else {
                        this.$refs.closeModalExecut.click();
                    }

                } catch(error){}
            }
        });
    },
    watch: {
    },
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modalExecutors.vue